import { Component } from '@angular/core';
import { EOProduct, EOStatusType } from '../../../modal/entity.modal';
import { FnToasterService, FnUtilService } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';
import { HwDialogData } from '../../dashboard/dashboard-info-model/dashboard-info-model.component';

@Component({
  selector: 'app-alert-help-setup',
  templateUrl: './alert-help-setup.component.html',
  styleUrl: './alert-help-setup.component.scss'
})
export class AlertHelpSetupComponent {


  constructor(private posHttpSvcs: PosHttpService, private toaster: FnToasterService, private fnutilservice: FnUtilService){}

  ngOnInit(): void {
    this.getProduct();
  }
  //isloading : boolean = false
  selectProduct: any;
  selectIdenNo: any;
  productArray: EOProduct[] = [];
  idenNoArray: EOStatusType[] = [];

  getProduct() {
    this.posHttpSvcs.authGet('v1/ui/loadProductName', 'loadProductName').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Product name not loaded');
        return;
      }
      this.productArray = resp.data;
    });
  }

  getIdeno() {
    this.selectIdenNo = '';
    this.objectHash.helpURL = '';
    this.posHttpSvcs.authPost('v1/ui/loadIdenNo', 'loadIdenNo', this.selectProduct).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Product not Selected');
        return;
      }
      this.idenNoArray = resp.data;
    })
  }

  onIdenNoChange() {
    const selected = this.idenNoArray.find(value => value.idenNo === this.selectIdenNo);
    if (selected) {
      this.objectHash.helpURL = selected.helpURL || '';
    }
  }

  objectHash: EOStatusType = {
    primaryKey: 0,
    idenNo: '',
    productName: '',
    helpURL: '',
    cause: '',
    defaultEscEmailID: '',
    resolution: '',
    uniqueKey: '',
    resetOffsetTimeInMin: 0,
    typeIID: '',
    countForCriticality: 0,
    escEmailSub: '',
    isAutoEscalate: false,
    isActive: false,
    isManualResolvable: false,
    isSendToTeligram: false,
    isCountBreach: false,
    isDualConditional : false,
    breachCount: 0,
    isSendMail: false,
    teams:[],
  }

  setAlertHelp(): void {
    if (this.fnutilservice.isEmptyObject(this.objectHash.helpURL)) {
      this.toaster.error('Please add help Url..');
      return
    }
    const alertHelp = {
      idenNo:  this.selectIdenNo,
      helpUrl: this.objectHash.helpURL

    };
    this.posHttpSvcs.authPost('v1/ui/addAlertHelp', 'addAlertHelp', alertHelp).subscribe(resp => {
      if (resp.isError) {
        this.toaster.error('Alert help not added');
        return;
      } else {
        this.toaster.success(resp.data);
      }
    });
  }
}
